import ImageUtils from '@gik/core/utils/ImageUtils';
import dataURLtoBlob from 'blueimp-canvas-to-blob';

export interface AttachImageResult {
  blob: Blob;
  base64: string;
  width: number;
  height: number;
}

export default class FileUtils {
  static async attachImage(maxSize = 1024): Promise<AttachImageResult> {
    const fileInput = document.createElement('input');

    fileInput.type = 'file';
    fileInput.accept = ['.gif', '.png', '.jpg', '.jpeg'].join(', ');
    fileInput.hidden = true;
    document.body.appendChild(fileInput);

    return new Promise<AttachImageResult>(resolve => {
      fileInput.addEventListener('change', async fileChangeEvent => {
        const target = fileChangeEvent.target as HTMLInputElement;
        if (target.files && target.files.length > 0) {
          const file = target.files[0];
          fileInput.remove();

          const imageUrl = await new Promise<string>(onFileLoaded => {
            const fileReader = new FileReader();
            fileReader.onload = function () {
              onFileLoaded(fileReader.result.toString());
            };
            fileReader.readAsDataURL(file);
          });

          const onFixOrientation = () => {
            const resizeSize = Math.min(maxSize, Math.max(image.width, image.height));

            const canvas = ImageUtils.resizeToCanvas(image, resizeSize);

            const base64 = ImageUtils.canvasToJpegBase64(canvas);
            const blob = dataURLtoBlob(base64);

            resolve({ blob, base64, width: canvas.width, height: canvas.height });
          };

          const image = await ImageUtils.createImage(imageUrl);

          ImageUtils.getOrientation(file, function (orientation) {
            ImageUtils.fixOrientation(orientation, image, onFixOrientation);
          });
        } else {
          resolve(null);
        }
      });

      fileInput.click();
    });
  }
}
